export const groupBy = (_array: any[], sortBy: string) =>
  _array.length > 0 &&
  _array.reduce((previous, current) => {
    const type = current[sortBy];
    previous[type] = previous[type] ?? [];
    previous[type].push(current);
    return previous;
  }, {});
